export default __webpack_public_path__ + "static/media/Plantilla_lista_invitados.25414900.xlsx";